import React from 'react';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
export default function AccessControlError(props) {
  return (
    <div id="access-control-error-main-container" className="mainContainer">
      <div id="access-control-error-inner-container" className="innerContainer">
        <div
          id="access-control-error-login-wrapper"
          className="login flex-y-center flex-column"
        >
          <div
            id="access-control-error-login-form"
            className="loginForm flex-y-center flex-column"
            style={{ padding: '24px' }}
          >
            <div
              id="access-control-error-login-heading"
              className="loginHeading flex-y-center"
            >
              <div id="access-control-error-icon">
                <RMSvgIcon
                  id="access-control-error-icon-rm-logo"
                  name="RMLogo"
                  height={48}
                  width={48}
                />
              </div>
              <div
                id="access-control-error-license-wrapper"
                style={{ marginLeft: 16, paddingBottom: 5 }}
              >
                <div
                  id="access-control-error-license-header-1"
                  className="license-header"
                >
                  ROCK MAKER
                  <span
                    id="access-control-error-registered-logo"
                    className="registeredLogo"
                  >
                    &#174;
                  </span>
                </div>
                <div
                  id="access-control-error-license-header-2"
                  className="license-header2"
                >
                  Crystallization Software
                </div>
              </div>
            </div>

            <div
              id="access-control-error-license-style"
              style={{ width: '100%', alignSelf: 'flex-start' }}
            >
              <div
                id="access-control-error-license-content"
                className="license-header"
                style={{ alignSelf: 'start', marginLeft: 24 }}
              >
                Access control is not enabled in your Rock Maker. Please enable access
                control, so that you can use the Rock Maker.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
